export default "__VITE_ASSET__W1jXFa86__"